import { ClSceneType, LoanType } from '@/interface/CL/clCredit';
import { CreditHomeNode, CreditState } from '@/pages/KKC/loading/ValidateLogic/interface';

export interface BankCardType {
  bankId?: string; // 银行编号
  bankCardName?: string; // 银行卡名
  bankCardEnName?: BankTypeEnum; // 银行卡英文名
  bankCardNum?: string; // 银行卡号
  bankCardNum1?: string; // 银行卡号脱敏展示
  bankCardNumEncrypt?: string; // 银行卡号2
  bankCardType?: string; // 银行卡类别
  // BILL("1", "信用卡"),
  // BANK("2", "储蓄卡"),
  // AGENCY("3", "机构信用卡"),
  // CHEQUE("4", "支票"),
  // DC_SETTLEMENT("5", "DC借新还旧"),
  // INSTALMENT("6", "分期付款");
  // "7" APP借新还旧
  // "9" CS借新还旧
  bankLoanAmt?: number; // 银行卡贷款结清金额
  bankRepaymentTime?: string; // 账单还款日
  state?: BankStateType; // 状态 1 申请成功，2 申请失败，3 处理中 4. DBS 处理中(Pending)
  statementDate?: string; // 结款日
  auditReason?: string; // 审核原因
  orderId?: string; // 提现id
  bankAllLoanAmt?: number; // 银行卡贷款金额
  token?: string; // 关联账单token

  createBy?: string; //
  createdTime?: string; //
  creditId?: string; // 授信id
  id?: string; // 主键id，自增
  isDelete?: string; //
  msgId?: string; // 放款id
  paymentTime?: string; // 放款成功时间
  productCode?: string; // 产品value
  updateBy?: string; //
  updatedTime?: string; //
  userId?: number; // 用户id

  isCanUpdateBankNum?: boolean; // 是否可以在提现页面执行编辑，配合渣打银行SCB使用
  encryptionBankNum?: string; // 银行卡的掩码形态
  billId?: number;
  contractNo?: string; // 合约号
}

export enum BankStateType {
  Success = '1', // 成功
  Reject = '2', // 拒绝
  Handling = '3', // 处理中
  Pending = '4', // pending
  NamePending = '5', // 账单解析名字处理中
}

export enum EntrySceneType {
  Main_Deliver = '1', // 主入口的可交单校验
  Repay_Entry_Deliver = '2', // App入口首次可交单规则校验
  Repay_Deliver = '3', // App入口 立即还卡数后触发的可交单校验
}

// 银行类型
export enum BankTypeEnum {
  BOC = 'BOC', // 中国银行
  HSBC = 'HSBC', // 汇丰
  SCB = 'SCB', // 渣打
  CITI = 'CITI', // 花旗
}

export enum BoolString {
  YES = 'Y',
  NO = 'N',
}

export enum BooleanString {
  YES = 'true',
  NO = 'false',
}

export type LoanEntity = {
  avlAmt?: number; // 可用额度
  annualInterestRate?: number; // 实际年利率
  creditId?: string; // 授信id
  loanAmt?: number; // 贷款金额
  loanCommission?: number; // 贷款手续费
  loanMaturity?: number; // 贷款期数
  monthPacify?: string; // 月平息
  orderId?: string; // 提现id
  repaymentAmt?: number; // 每月还款金额
  repaymentTime?: string; //	每月还款日		false
  repaymentCutoffTime?: string; // 还款截止日
  state?: CreditState; // 状态
  usableLoanAmt?: number; // 可用授信额度
  firstRepaymentDate?: string; // 首次還款日期
  paymentBankFlows?: BankCardType[];
  repaymentPeriods?: number[]; // 选择期数
  isCreditAgain?: number;
  maxMaturity?: number; // 最大期数
  minMaturity?: number; // 最小期数
  repaymentPlans?: repaymentPlan[];
  totalInterest?: number; // 利息总额
  entryScene?: EntrySceneType;
  applyId?: string; // 授信过来的id
  rates?: {
    maxMaturity: number;
    minMaturity: number;
    avlAmt: number;
  }[];
  totalLoanAmt?: number; // 还款总额
  failReason?: string; // 失败原因
  auditReason?: string; // 原因
  isSms?: BoolString;
  isPwd?: BoolString;
  homeNode?: CreditHomeNode; // homenode，原生处理的信息
  divRepaymentTime?: string; // 自定義還款日
  monthPacifyActivity?: string; // 活动月平息
  annualInterestRateActivity?: string; // 活动年利率
  loanType?: LoanType;
  couponId?: string; // 优惠券id
  couponType?: string; // 优惠券类型
  firstRepaymentAmt?: number; // 首月还款金额
  productScene?: ClSceneType | undefined;
} & {
  refactoredVersion?: boolean;
};

// annualInterestRate: 7.7777
// firstRepaymentDate: "5月5日"
// monthPacify: "6.6666"
// repaymentAmt: 666.66
// repaymentCutoffTime: "5"

// 还款计划
export interface repaymentPlan {
  createBy: string;
  createdTime: string;
  id: 0;
  isDelete: string;
  orderId: string;
  repaymentAmt: 0; // 还款金额
  repaymentCutoffTime: string; // 还款截止日
  repaymentInterest: 0; // 还款利息
  repaymentMaturity: string; // 还款期数（首期1，2期.....）,1-10
  repaymentPrincipal: 0; // 还款本金
  repaymentTime: string; // 	实际还款时间
  state: string; //	还款状态
  updateBy: string;
  updatedTime: string;
  billTime: string; // 时间

  billId?: string; // 账单ID
  isEarlySettlement?: string; // 是否提前结清
  overdueDay?: string; // 逾期天数
  receivedRepaymentAmt?: number; // 已还金额
  recentRepaymentTime?: string; // 最近还款时间
  remainRepaymentAmt?: number; // 剩余结清金额
  remark?: string; // 备注
  userId?: number; // 用户ID
}

export interface repaymentPlanList {
  repaymentPeriods: number[];
  repaymentPlans: repaymentPlan[];
  totalInterest: number; // 利息总额
  repaymentAmt: number; // 还款总额
  firstRepaymentAmt?: number; // 首月还款金额

  // 防止ts的报错
  totalLoanAmt?: number;
  monthPacifyStandard?: string;
  monthPacify?: string;
  annualInterestRate?: number;
  monthPacifyActivity?: string;
  annualInterestRateActivity?: string;
}

export type ContractInfoType = {
  contractNo: string;
  orderId: string;
  pdfUrl: string;
  jpgUrl: string[];
};

export type LoanEntityWithdrawal = {
  annualInterestRate?: number; // 实际年利率
  creditId?: string; // 授信id
  loanAmt?: number; // 贷款金额
  loanCommission?: number; // 贷款手续费
  loanMaturity?: number; // 贷款期数
  monthPacify?: string; // 月平息
  orderId?: string; // 提现id
  repaymentAmt?: number; // 每月还款金额
  repaymentTime?: string; //	每月还款日		false
  repaymentCutoffTime?: string; // 还款截止日
  state?: WithdrawalState; // 状态
  usableLoanAmt?: number; // 可用授信额度
  firstRepaymentDate?: string; // 首次還款日期
  paymentBankFlows?: BankCardType[];
  repaymentPeriods?: number[]; // 选择期数
  isCreditAgain?: number;
  maxMaturity?: number; // 最大期数
  minMaturity?: number; // 最小期数
  repaymentPlans?: repaymentPlan[];
  totalInterest?: number; // 利息总额
  entryScene?: EntrySceneType;
  applyId?: string; // 授信过来的id
  rates?: {
    maxMaturity: number;
    minMaturity: number;
  }[];
  totalLoanAmt?: number; // 还款总额
  failReason?: string; // 失败原因
  auditReason?: string; // 原因
  isSms?: BoolString;
  isPwd?: BoolString;
  homeNode?: CreditHomeNode; // homenode，原生处理的信息
  divRepaymentTime?: string; // 自定義還款日
  reason?: string; // 审核失败原因
  payBillRecord?: payBillRecordDto; //
};

export type payBillRecordDto = {
  reason?: string; // 失败原因
  state?: string; // 提现审核状态
  id?: string;
};

export enum WithdrawalState {
  NamePending = '01', // 名字审批中
  NameReject = '01-2', // 名字审批拒绝

  WithdrawalPending = '02', // 提現賬單风控中
  WithdrawalApprove = '02-1', // 提現賬單风控通过
  WithdrawalReject = '02-2', // 提現賬單风控失败
}

export type SureLoanParamsType = LoanEntity & { orderId: string };

export enum OtpResultType {
  EXPIRE = '01', // 失效
  FAIL = '02', // 不匹配
  SUCCESS = '03', // 成功
  OVER_LIMIT = '04', // 超出次數
}

export type checkOtpVecodeType = {
  otpResult?: OtpResultType;
};
